export class StartGitIntegrationAuthorizationInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "returnUrl",
            "baseName": "returnUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartGitIntegrationAuthorizationInput.attributeTypeMap;
    }
    constructor() {
    }
}
